const $doc = $(document);

$doc.on('input', '#bc-sf-search-box-mobile', function() {
  const fieldVal = $(this).val();
  
  $('.bc-sf-search-box.search__field').val(fieldVal);
});

$doc.on('click', '.bc-sf-search-btn-clear-suggestion', function() {
  $('body').removeClass('search-mobile-expanded');
});

$doc.on('click', '.js-btn-search', function(e) {
  e.preventDefault();

  $('body').addClass('search-mobile-expanded');

  if ($('#bc-sf-search-box-mobile').length) {
    $('#bc-sf-search-box-mobile').trigger('focus');
  };
});

$doc.on('click touchstart', function(e) {
  const $target = $(e.target);
  if (!$target.hasClass('js-search') && !$target.closest('.js-search').length && !$target.hasClass('js-btn-search-desktop') && !$target.closest('.js-btn-search-desktop').length && !$target.hasClass('bc-sf-search-suggestion-wrapper') && !$target.closest('.bc-sf-search-suggestion-wrapper').length) {
    $('.header').removeClass('header--search');
  }
});



// WEBPACK FOOTER //
// ../assets/js/search.js